// extracted by mini-css-extract-plugin
module.exports = {"title":"logo-module--title--3XoBy","span":"logo-module--span--2KHEW"};